export const baseUrl = "https://talkgpt-be-production.up.railway.app/";
// export const baseUrl = "http://localhost:8000/";

export const googleClientId =
  "514596053287-kh377v8qfh3fhnmc7p8ab0g8idr9san2.apps.googleusercontent.com";
